module.exports = __webpack_public_path__ + "static/images/ui/ui-bg_inset-soft_30_f58400_1x100.png";